var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechPattern3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 559.64 76.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.2;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.55px;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ex_2",
    "data-name": "ex 2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "0.14 63.93 21.57 76.31 43.01 63.93 43.01 39.18 21.57 26.8 0.14 39.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "85.88 63.93 85.88 39.18 64.44 26.8 43.01 39.18 43.01 63.93 64.44 76.31 85.88 63.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "171.62 63.93 171.62 39.18 150.19 26.8 128.75 39.18 128.75 63.93 150.19 76.31 171.62 63.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "214.49 63.93 214.49 39.18 193.06 26.8 171.62 39.18 171.62 63.93 193.06 76.31 214.49 63.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "300.24 63.93 300.24 39.18 278.8 26.8 257.37 39.18 257.37 63.93 278.8 76.31 300.24 63.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "300.24 39.18 300.24 63.93 321.67 76.31 343.11 63.93 343.11 39.18 321.67 26.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "385.98 63.93 385.98 39.18 364.54 26.8 343.11 39.18 343.11 63.93 364.54 76.31 385.98 63.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "471.72 63.93 471.72 39.18 450.29 26.8 428.85 39.18 428.85 63.93 450.29 76.31 471.72 63.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "514.59 63.93 514.59 39.18 493.16 26.8 471.72 39.18 471.72 63.93 493.16 76.31 514.59 63.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "557.46 63.93 557.46 39.18 536.03 26.8 514.59 39.18 514.59 63.93 536.03 76.31 557.46 63.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "128.75 63.93 128.75 39.18 107.31 26.8 85.88 39.18 85.88 63.93 107.31 76.31 128.75 63.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "214.49 39.18 214.49 63.93 235.93 76.31 257.37 63.93 257.37 39.18 235.93 26.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "428.85 63.93 428.85 39.18 407.41 26.8 385.98 39.18 385.98 63.93 407.41 76.31 428.85 63.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "21.47 26.87 42.91 39.25 64.34 26.87 64.34 2.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "107.22 26.87 128.65 39.25 150.09 26.87 150.09 2.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "150.09 2.12 150.09 26.87 171.52 39.25 192.96 26.87 192.96 2.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "235.83 26.87 257.26 39.25 278.7 26.87 278.7 2.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "278.7 2.12 278.7 26.87 300.14 39.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "321.57 26.87 343.01 39.25 364.44 26.87 364.44 2.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "407.31 2.12 407.31 26.87 428.75 39.25 450.19 26.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "450.19 26.87 471.62 39.25 493.06 26.87 493.06 2.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "493.06 2.12 493.06 26.87 514.49 39.25 535.93 26.87 535.93 2.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "64.34 2.12 64.34 26.87 85.78 39.25 107.22 26.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "192.96 2.12 192.96 26.87 214.39 39.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "364.44 2.12 364.44 26.87 385.88 39.25 407.31 26.87 407.31 2.12"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 536.07,
    cy: 26.84,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 493.2,
    cy: 26.84,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 450.34,
    cy: 26.84,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 407.47,
    cy: 26.84,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 364.6,
    cy: 26.84,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 321.74,
    cy: 26.84,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 278.79,
    cy: 26.84,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 235.92,
    cy: 26.84,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 193.05,
    cy: 26.84,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 150.18,
    cy: 26.84,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 107.32,
    cy: 26.84,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 64.46,
    cy: 26.84,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 21.56,
    cy: 26.84,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 536.07,
    cy: 2.19,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 493.2,
    cy: 2.19,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 407.47,
    cy: 2.19,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 364.6,
    cy: 2.19,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 278.79,
    cy: 2.19,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 193.05,
    cy: 2.19,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 150.18,
    cy: 2.19,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 64.46,
    cy: 2.19,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 557.45,
    cy: 39.18,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 557.45,
    cy: 63.93,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 514.58,
    cy: 39.18,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 514.58,
    cy: 63.93,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 471.7,
    cy: 39.18,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 471.7,
    cy: 63.93,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 428.83,
    cy: 39.18,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 428.83,
    cy: 63.93,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 385.96,
    cy: 39.18,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 385.96,
    cy: 63.93,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 343.09,
    cy: 39.18,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 343.09,
    cy: 63.93,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 300.22,
    cy: 39.18,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 300.22,
    cy: 63.93,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 257.35,
    cy: 39.18,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 257.35,
    cy: 63.93,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 214.48,
    cy: 39.18,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 214.48,
    cy: 63.93,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 171.6,
    cy: 39.18,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 171.6,
    cy: 63.93,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 128.73,
    cy: 39.18,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 128.73,
    cy: 63.93,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 85.86,
    cy: 39.18,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 85.86,
    cy: 63.93,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 42.99,
    cy: 39.18,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 42.99,
    cy: 63.93,
    r: 2.19
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechPattern3);
export default __webpack_public_path__ + "static/media/tech-pattern-3.47e93b38668bde51128a6c2569b93bf9.svg";
export { ForwardRef as ReactComponent };